import { styled } from "@mui/material/styles";

const sliderThumbIcon =
  'url(\'data:image/svg+xml,<svg width="53" height="62" viewBox="0 0 53 62" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(%23filter0_d_11717_129572)"><rect opacity="0.8" x="11.041" y="19" width="30.2695" height="30" rx="15" fill="%23F7F7FC" stroke="white" stroke-width="8"/><g filter="url(%23filter1_d_11717_129572)"><rect x="15.041" y="23" width="22.2695" height="22" rx="11" fill="white"/><rect x="16.041" y="24" width="20.2695" height="20" rx="10" stroke="%235E080B" stroke-width="2"/></g><path d="M22.4002 10.9895H29.6004C29.6733 10.9892 29.7448 10.9691 29.8071 10.9313C29.8694 10.8935 29.9203 10.8394 29.9541 10.7748C29.988 10.7103 30.0036 10.6377 29.9993 10.5649C29.995 10.4922 29.9709 10.422 29.9297 10.3619L26.3296 5.1617C26.1803 4.9461 25.8211 4.9461 25.6715 5.1617L22.0714 10.3619C22.0298 10.4218 22.0053 10.4921 22.0008 10.565C21.9962 10.6379 22.0117 10.7106 22.0456 10.7753C22.0795 10.84 22.1305 10.8942 22.193 10.9319C22.2555 10.9697 22.3272 10.9896 22.4002 10.9895Z" fill="%23830000"/></g><defs><filter id="filter0_d_11717_129572" x="0.0410156" y="0" width="52.2695" height="62" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="3.5"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11717_129572"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11717_129572" result="shape"/></filter><filter id="filter1_d_11717_129572" x="8.04102" y="18" width="36.2695" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="3.5"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11717_129572"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11717_129572" result="shape"/></filter></defs></svg>\')';

export const SliderContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  rowGap: "16px"
});

export const StyledSlider = styled("div")(({ theme, length, labelPosition = "top" }) => {
  let margin;
  if (labelPosition === "top") {
    margin = "40px  0 25px 0";
  } else {
    margin = "40px 0 45px 0";
  }

  return {
    color: "#525252",
    height: 12,
    margin,
    backgroundColor: "transparent !important",
    "& .MuiSlider-dragging": {
      backgroundColor: "transparent",
      boxShadow: "none"
    },
    "& .MuiSlider-thumb": {
      backgroundColor: "transparent",
      "&:focus, &:hover": {
        backgroundColor: "transparent",
        outline: "none",
        boxShadow: "none"
      },
      "&::after": {
        top: "36%", // Center vertically
        left: "50%", // Center horizontally
        transform: "translate(-50%, -50%)",
        backgroundColor: "transparent",
        backgroundRepeat: "no-repeat",
        backgroundImage: `${sliderThumbIcon}`,
        width: "50px",
        height: "60px"
      },
      "&.Mui-focusVisible": {
        boxShadow: "none"
      }
    },
    "& .MuiSlider-valueLabel": {
      top: "55px",
      left: "calc(-50% + 4px)"
    },
    "& .MuiSlider-track": {
      height: 12,
      borderRadius: 10,
      border: "1px solid var(--Color-Background-Secondary-Dark, #525252)",
      backgroundColor: "var(--Color-Background-Secondary-Dark, #525252)"
    },
    "& .MuiSlider-rail": {
      height: 12,
      borderRadius: 10,
      backgroundColor: "#E8E8E8"
    },
    "& .MuiSlider-markLabel": {
      ...(labelPosition === "top"
        ? {
            top: "-40px !important",
            paddingBottom: "5px"
          }
        : {
            top: "auto !important",
            bottom: "-30px !important", // Position labels below the slider
            paddingTop: "5px"
          }),

      fontWeight: 500,
      color: "var(--Color-Grey, #B8B8C0)",
      "&[data-index='0']": {
        transform: labelPosition === "top" ? "translateX(50%)" : "translateX(0%)" // Changed from translateX(50%) to align with left edge
      },
      [`&[data-index='${length - 1}']`]: {
        transform: "translateX(-100%)"
      },
      "&.MuiSlider-markLabelActive": {
        color: "var(--Color-Black, #3B3A3A)"
      }
    },
    "& .MuiSlider-markActive": {
      opacity: 0
    },
    "& .MuiSlider-mark": {
      display: "none"
    }
  };
});

export const Label = styled("span")({
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 500,
  marginBottom: "8px"
});

export const InfoTitle = styled("span")({
  fontSize: "12px",
  lineHeight: "16px",
  textAlign: "start"
});
